import type { SxProps, Theme } from "@mui/material/styles";

/**
 * Unified
 * Use these sx props directly on components instead of makeStyles modal styles for MUI v6
 */

export const modalStyles = {
  checkbox: {
    userSelect: "none",
  } satisfies SxProps<Theme>,

  errorLabel: {
    fontSize: 12,
    color: "error.main",
  } satisfies SxProps<Theme>,

  infoLabel: {
    fontSize: 12,
    color: "text.secondary",
  } satisfies SxProps<Theme>,

  autocompleteField: {
    display: "flex",
    alignItems: "center",
    paddingTop: 0,
    paddingBottom: 0,
  } satisfies SxProps<Theme>,

  modalContent: {
    padding: "15px 30px",
  } satisfies SxProps<Theme>,

  modalActions: {
    padding: "20px 30px 15px",
  } satisfies SxProps<Theme>,
};
